import { render, staticRenderFns } from "./SchoolGrid.vue?vue&type=template&id=5e27f073&"
import script from "./SchoolGrid.vue?vue&type=script&lang=js&"
export * from "./SchoolGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports